module.exports = __webpack_public_path__ + "img/no-fund.9dc6546a.png";